import axios from "axios";
import { API_BASE as SBIN_API_BASE } from "./base";

const API = SBIN_API_BASE;

function authHeaders() {
  const token = null;
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export async function downloadServiceImportTemplate() {
  const res = await axios.get(`${API}/services/import/template`, {
    headers: authHeaders(),
    responseType: "blob",
  });
  return res.data;
}

export async function createServiceImportJob({ file, salon_id }) {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("salon_id", salon_id);
  const res = await axios.post(`${API}/services/import/jobs`, formData, {
    headers: {
      ...authHeaders(),
      "Content-Type": "multipart/form-data",
    },
  });
  return res.data;
}

export async function previewServiceImportJob(jobId, payload) {
  const res = await axios.post(`${API}/services/import/jobs/${jobId}/preview`, payload, {
    headers: {
      ...authHeaders(),
      "Content-Type": "application/json",
    },
  });
  return res.data;
}

export async function commitServiceImportJob(jobId, payload) {
  const res = await axios.post(`${API}/services/import/jobs/${jobId}/commit`, payload, {
    headers: {
      ...authHeaders(),
      "Content-Type": "application/json",
    },
  });
  return res.data;
}

export async function listServiceImportJobs({ salon_id, page = 1, per_page = 10 }) {
  const res = await axios.get(`${API}/services/import/jobs`, {
    params: { salon_id, page, per_page },
    headers: authHeaders(),
  });
  return res.data;
}

export async function getServiceImportJob(jobId) {
  const res = await axios.get(`${API}/services/import/jobs/${jobId}`, {
    headers: authHeaders(),
  });
  return res.data;
}

export async function rollbackServiceImportJob(jobId) {
  const res = await axios.post(
    `${API}/services/import/jobs/${jobId}/rollback`,
    {},
    {
      headers: authHeaders(),
    }
  );
  return res.data;
}
